// extracted by mini-css-extract-plugin
export default {"newGroupInput":"DraggableChecks_newGroupInput__w6aDT","checkGroups":"DraggableChecks_checkGroups__Au0le","row":"DraggableChecks_row__Z9fUd"};